export const viaOptions = [
  { value: "KITE", label: "KITE" },
  { value: "DOTNET", label: "DOTNET" },
];

export const badlaTypeOptions = [
  { value: "GOLD", label: "GOLD" },
  { value: "SILVER", label: "SILVER" },
  { value: "COPPER", label: "COPPER" },
  { value: "CRUDE", label: "CRUDE" },
  { value: "GAS", label: "NATURAL GAS" },
  { value: "OTHER", label: "OTHER" },
];
